import styled from 'styled-components';
import ConfirmPrintSvg from '../../../assets/onboarding/newHome/confirm-print.svg';

const ConfirmPrintIcon = styled(ConfirmPrintSvg as React.SFC<React.SVGProps<SVGSVGElement>>)`

width: ${props => props.width || '4.2rem'};
height: ${props => props.height || '4.2rem'};
display: flex;
`;

export default ConfirmPrintIcon;
